@if (client$ | async; as client) {
    <a (click)="getInvitationLink(client)">Get a shareable link</a>
}
